export default __webpack_public_path__ + "static/media/Paula-Mari_Ferreira.815d832d.jpeg";